import React, { useCallback } from 'react';
import RadioGroupAdapter from '../../adapters/radioAdapter';
import type { EntityNextEventDropDownProps } from './types';

function EntityNextEventDropDown({
  code: entityNextEventDropDownCode,
  value,
  disabled,
  onChange,
  placeholder,
  showDisabledIcon,
  loading,
  customPayload,
  viewMode = false,
  ...props
}: EntityNextEventDropDownProps & {
  loading: boolean;
}) {
  const updatedValue = (customPayload?.entityNextEventOptions || [])?.find(
    (option) => option.code === value,
  )?.value;
  const onChangeEntityNextEventDropDown = useCallback(
    (selectedOptions, event) => {
      const { code } = selectedOptions[0];
      onChange(code, event, { data: { code } });
    },
    [onChange],
  );

  return (
    <RadioGroupAdapter
      value={updatedValue}
      disabled={disabled}
      onChange={onChangeEntityNextEventDropDown}
      meta={{ viewType: 'chipRadio', placeholder }}
      loading={loading}
      viewMode={viewMode}
      showDisabledIcon={showDisabledIcon}
      {...props}
      // @ts-ignore
      options={customPayload.entityNextEventOptions || []}
    />
  );
}

export default EntityNextEventDropDown;
